import { createSelector } from '@reduxjs/toolkit';
import getItems from './getItems';
import { getDayPartMenuConfig } from './config';
import { checkTimeAvailability } from '../utils/ordering/daypartMenuAvailability';
import getOrderDateTimeSelected from './getOrderDateTimeSelected';

/**
 * # Get ItemAvailability By Id
 * This is used by these components:
 * - <StagedPurchases />
 */
export default (id?: string) =>
  createSelector(
    [getItems, getDayPartMenuConfig, getOrderDateTimeSelected],
    (items, { dayPartTimeBracket = 0 }, dateTimeSelected): boolean => {
      if (!items || !id || !items[id]) return true;
      const { availability, days, start, end } = items[id];

      return availability
        ? checkTimeAvailability({
            availability,
            days,
            start,
            end,
            timeBracket: dayPartTimeBracket,
            dateTimeSelected,
          })
        : true;
    },
  );
